import { render, staticRenderFns } from "./password-form.vue?vue&type=template&id=7defa588&scoped=true&"
import script from "./password-form.vue?vue&type=script&lang=js&"
export * from "./password-form.vue?vue&type=script&lang=js&"
import style0 from "./password-form.vue?vue&type=style&index=0&id=7defa588&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7defa588",
  null
  
)

export default component.exports